import React from 'react';

import { CreateJira } from 'containers/Setup/Integrations/Components/IntegrationsWizard/Jira/Components/CreateJira';
import { EditJira } from 'containers/Setup/Integrations/Components/IntegrationsWizard/Jira/Components/EditJira';
import { useIntegrationsContext } from 'containers/Setup/Integrations/context/context';


export const JiraWizard = () => {
  const { actionType } = useIntegrationsContext();

  return actionType === 'Add' ? <CreateJira /> : <EditJira />;
};
